import React from "react";
import { Linkedin, Award, Sparkles, Users } from "lucide-react";

const ABOUT_IMG = "/coach.jpg";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="border-b border-black/10 bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -top-4 -right-4 hidden md:block w-full h-full border border-black" />
              <div className="relative border border-black overflow-hidden bg-white">
                <img
                  src={ABOUT_IMG}
                  alt="Ruchika Thakkar Singh"
                  className="w-full aspect-square object-contain bg-white"
                />
              </div>
              <div className="mt-4 flex items-center gap-3">
                <a
                  href="https://www.linkedin.com/in/ruchika-thakkar-singh/"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="about-linkedin"
                  className="btn-secondary text-sm"
                >
                  <Linkedin size={16} /> LinkedIn
                </a>
                <span className="text-sm text-neutral-500">
                  ruchika-thakkar-singh
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="overline mb-4">About</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-black leading-[0.98]">
              Meet <span className="bg-[color:var(--bts-yellow)] border border-black px-2">Ruchika</span> —
              your behaviour catalyst.
            </h2>
            <p className="mt-6 text-neutral-700 text-base md:text-lg leading-relaxed max-w-2xl">
              Ruchika Thakkar Singh is a certified POSH trainer and Neuro
              Linguistic Programming (NLP) practitioner. She designs behavioural
              interventions that move people from awareness to lasting action —
              for enterprises, educational institutes and rising professionals.
            </p>

            <div className="mt-10 grid sm:grid-cols-3 gap-4">
              <Cred
                icon={<Award size={20} />}
                title="Certified POSH Trainer"
                sub="Compliance-ready workshops"
              />
              <Cred
                icon={<Sparkles size={20} />}
                title="NLP Practitioner"
                sub="Mindset & communication"
              />
              <Cred
                icon={<Users size={20} />}
                title="Corporate & Campus"
                sub="Virtual · In-person"
              />
            </div>

            <div className="mt-10 border-t border-black/10 pt-6 flex flex-wrap gap-x-8 gap-y-3 text-sm text-neutral-600">
              <span><b className="text-black">Focus:</b> Employee behaviour</span>
              <span><b className="text-black">Formats:</b> Workshops · Coaching</span>
              <span><b className="text-black">Delivery:</b> Pan-India · Global-online</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Cred = ({ icon, title, sub }) => (
  <div className="border border-black p-5 bg-white hover:bg-[color:var(--bts-yellow)] transition-colors">
    <div className="mb-3 text-black">{icon}</div>
    <div className="font-display text-lg text-black leading-tight">{title}</div>
    <div className="text-xs text-neutral-600 mt-1">{sub}</div>
  </div>
);

export default About;
